module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer016"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('p', {
    staticClass: "Part-number"
  }, [_c('span', {
    staticClass: "part-number _idGenCharOverride-2"
  }, [_vm._v("Part I")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-title"
  }, [_vm._v("Class Struggle in "), _c('span', {
    staticClass: "Part-title _idGenCharOverride-3"
  }, [_vm._v("the")]), _vm._v(" "), _c('br'), _vm._v("“Land of Opportunity,” 1865–1930 ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-669203ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part1.vue
// module id = 87
// module chunks = 0